<template>
  <div class="animated fadeIn">
    <b-card>

      <!-- HEADER -->
      <template #header>
     
            <b-col md="11">
                <strong  >Vehicle Movement Today</strong>
            </b-col>

            <b-col md="1">
                <b-button class="ml-auto" size="sm" variant="secondary" @click="goback()"> Back
              </b-button>
            </b-col>
            
      </template>
      <div id="listloader" v-if="loader">
          <div class="listloader"></div>
        </div>

      <b-row class="mt-3 text-center">
        <b-col 
          v-for="(item, index) in summaryList" 
          :key="index"
        >
          <div
            class="shipment-box"
            :class="{ 
              clickable: Number(item.value) > 0, 
              disabled: Number(item.value) === 0 
            }"
            :style="{ backgroundColor: item.color }"
            @click="Number(item.value) > 0 ? handleCardClick(item) : null"
          >
            <div class="title">{{ item.title }}</div>
            <div class="value">{{ item.value }} Vehicles</div>
          </div>
        </b-col>
      </b-row>


        <!-- DRILLDOWN SECTION -->
        <div v-if="showHubSection" class="mt-4 hub-section" >

            <div class="d-flex justify-content-between align-items-center mb-2">
                <strong>{{ fisttitle }}</strong>
                <b-button size="sm" variant="secondary" @click="showHubSection = false, showVehicleTable = false">
                Close
                </b-button>
            </div>

            <b-row class="text-center">
                <b-col 
                v-for="(hub, index) in hubList" 
                :key="index" 
                md="3"
                class="mb-2"
                >
                <div class="hub-box clickable"
                @click="handleCardClickvehicledetails(hub)">
                    <div class="hub-title">{{ hub.name }}</div>
                    <div class="hub-value">{{ hub.count }}</div>
                </div>
                </b-col>
            </b-row>

        </div>
        <!-- VEHICLE DETAILS -->
    <div v-if="showVehicleTable" class="mt-3">

      <div class="d-flex justify-content-between mb-2">
        <strong>{{ secondtitle }}</strong>
        <p>Total Count: <span style="color:red; font-weight: 700;">{{ totalcount }} </span></p>
        <b-button size="sm" @click="showVehicleTable = false">Close</b-button>
      </div>
      
        <b-table 
        :items="vehicleTableData"
        :fields="vehicleFields"
        small
        bordered
        >
         <template slot="shipmentcount" slot-scope="row">
             <span 
                class="clickable-link"
                @click="openLoadPopup(row.item.currenthubid, row.item.vehicle_id, row.item.warehouseid, row.item.tripid)"
              >
                {{ row.item.total_parentawb_count }}
              </span>
         </template>
        </b-table>

         <b-col md="12" class=" " v-if="totalcount > 0">
            <paginate 
            v-model="pageNum"
            :page-count="noofpages"
            :page-range="10"
            :margin-pages="2"
            :click-handler="clickCallback"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'">
            </paginate>
        </b-col>

    </div>
    </b-card>
    <b-modal v-model="showLoadModal" title="Load ID Details" size="lg">

      <b-table 
        :items="loadData"
        :fields="loadFields"
        bordered
        small
      ></b-table>

      <b-col md="12" class=" " v-if="total_count > 0">
          <paginate 
          v-model="pageNum1"
          :page-count="noofpages1"
          :page-range="10"
          :margin-pages="2"
          :click-handler="clickCallback1"
          :prev-text="'Prev'"
          :next-text="'Next'"
          :container-class="'pagination'"
          :page-class="'page-item'">
          </paginate>
        </b-col>
    </b-modal>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Filters from '@/utils/filters'
import Utils from '@/utils'
import { EventBus } from "./event-bus.js";
export default{
    
data(){
    return{
     summaryList: [
      { key:'LH', title: "Line Haul Vehicle(Mid Mile)", value: 0,  color: "#17a2b8" },
      { key:'NationalLH', title: "National Line Haul Vehicle(Mid Mile)", value: 0, color: "#28a745"  },
      { key:'OFD', title: "Direct Delivery Vehicle(Last Mile)", value: 0, color: "#ffc107"  },
      { key:'PickDone', title: "Pickup Vehicle(First Mile)", value: 0,  color: "#dc3545" },
     
    ],
    showHubSection:false,

    hubList: [],
    showVehicleTable: false,
    showLoadModal: false,
    vehicleTableData: [],
    vehicleFields:[],


    loadFields: [
      { key: "load_id", label: "Load ID" },
      { key: "parentawb", label: "AWB" },
      { key: "shipmentstatus", label: "Status" }
    ],

    loadData: [],
    userType:"",
    Usersysuserid:"",
    user_id:"",
    route_id: null,
    selectedstatus:"",
    fisttitle:'',
    secondtitle:'',
    totalcount:0,
    total_count:0,
    pageNum:1,
    pageNum1:1,
    noofpages:'',
    noofpages1:'',
    totalRows: 0,
    selectedhubid:'',
    selectedcurrenthubid:'',
    selectedvehicleid:'',
    selectedwarehouseid :'',
    selectedtripid:'',
     loader:false,
 
    }
},

created(){
  console.log("this.$route.query", this.$route.query)
  var userdata = localStorage.getItem("userData");
  var userInfo = JSON.parse(userdata);
  this.userType=userInfo.user_type;
  this.Usersysuserid=userInfo.sysusermasterid;
  this.user_id = userInfo.sysusermasterid;
  this.route_id = this.$route.params.id || 'normal'
  this.getvehiclemovementtoday()
},

methods:{
    handleCardClick(item) {
        // console.log(item )       
     if (item) {
      this.selectedstatus= item.key 
      if(this.selectedstatus == 'OFD'){
        this.fisttitle = 'Direct dispatch vehicle Hubwise Dispatch'
      }
      else if(this.selectedstatus == 'PickDone'){
         this.fisttitle = 'Pickup vehicle stockist wise Dispatch'
      }
      this.getvehiclewisehubdetails();
        this.showHubSection = true
        this.showVehicleTable = false
     } else {
        this.showHubSection = false
        this.showVehicleTable = false
        this.fisttitle ='';
     }
    },
    handleCardClickvehicledetails(hub) {
    if(hub){
     if(this.selectedstatus == 'OFD'){
        this.secondtitle = 'Vehicle waise direct dispatch'
      }
      else if(this.selectedstatus == 'PickDone'){
         this.secondtitle = 'Vehicle wise pickup'
      }
    this.showVehicleTable = true
    this.selectedhubid= hub.id
    this.getshipmentcountandvehicledetails(hub.id, this.pageNum);
    }
    else{
      this.secondtitle ="";
      this.showVehicleTable = false
    }
  },

  clickCallback(pageNum){
    this.getshipmentcountandvehicledetails(this.selectedhubid, pageNum)
  },

  clickCallback1(pageNum1){
    this.getshipmentdetailsforvehicle( this.selectedcurrenthubid,
    this.selectedvehicleid,
    this.selectedwarehouseid ,
    this.selectedtripid )
  },

  getshipmentcountandvehicledetails(hubid, pageNum){
     this.loader= true;
    const obj={
      hub_id: this.$route.query.hub_id || '',
      sysusermasterid: this.Usersysuserid,
      warehouseid: this.$route.query.warehouseid || '',
      edd: this.$route.query.edd || '',
      shipmentjourney: this.$route.query.shipmentjourney || '',
      shipmentstatus: this.selectedstatus,
      currenthubid: hubid,
      page_no: pageNum
    }

    this.$http
      .post(`${CONSTANTS.MISREPORT_API_URL}/getshipmentcountandvehicledetails`, obj)
      .then(result => {
        this.loader = false;

        if (result.data.returnmsg === "Successful") {
          // console.log(result.data.returnvalue)
          this.vehicleTableData =result.data.returnvalue
          this.totalcount = result.data.returnvalue[0].totalcount
          this.noofpages=parseInt(this.totalcount)/10;
          this.noofpages=Math.ceil( this.noofpages);
          let extraFields =[];
          let commonFields =[     
             { key: "vehicle_no", label: "Vehicle Number" },
              { key: "vehicle_type", label: "Vehicle Type" },
              { key: "vehicledimensionsweight", label: "Vehicle Dimensional Weight" ,
                formatter: value => value || 'NA',
              },
              { key: "transporter_company_name", label: "Transporter company name",
                formatter: value => value || 'NA',
              }
          ]
          // alert(this.selectedstatus)
          if(this.selectedstatus == 'OFD'){
            extraFields= [
              { key: "hub_title", label: "Dispatch Hub Name" },
              { key: "origin", label: "Vehicle Trip" ,
                formatter: value => value || 'NA',
              },
              { key: "startdate", label: "Trip Sumbit Date",
                formatter: value => value || 'NA',
              },
              { key: "shipmentcount", label: "Shipment Count",
                formatter: value => value || 0,
              },
              { key: "total_mpscount", label: "Box Count",
                formatter: value => value || 'NA',
              },
              { key: "destinationcity", label: "Destination Cities",
                formatter: value => value || 'NA',
              },
            ]
         
          }
          if(this.selectedstatus == 'PickDone'){
            extraFields= [
              { key: "warehouseid", label: "warehouse Id", 
               formatter: value => value || 'NA', },
            
              { key: "warehousename", label: "Warehouse Name",
                formatter: value => value || 'NA',
              },
              { key: "shipmentcount", label: "Shipment Count",
                formatter: value => value || 0,
              },
              { key: "total_mpscount", label: "Box Count",
                formatter: value => value || 'NA',
              },
              
            ]
            // this.vehicleFields =[...extraFields]
          }

           this.vehicleFields = [...commonFields, ...extraFields]
          
        }else{
          this.vehicleTableData = []
        }

      })
    
  },

  openLoadPopup(currenthubid, vehicleid, warehouseid, tripid) {
    // console.log("Shipment clicked:", row.item)
    this.showLoadModal = true
    this.selectedcurrenthubid = currenthubid;
    this.selectedvehicleid = vehicleid ;
    this.selectedwarehouseid = warehouseid ;
    this.selectedtripid = tripid ;
    this.getshipmentdetailsforvehicle(currenthubid, vehicleid, warehouseid, tripid, this.pageNum1);
  },

  getshipmentdetailsforvehicle(currenthubid, vehicleid, warehouseid, tripid, pageNum1){
    // console.log("this.$route.query.warehouseid", this.$route.query.warehouseid);
     this.loader= true;
    let tempwarehouseid
    if(warehouseid){
      tempwarehouseid = warehouseid.split(",");
    }
   
    const obj ={
      shipmentstatus :this.selectedstatus,
      currenthubid: currenthubid,
      warehouseid: tempwarehouseid || '',
      vehicle_id: vehicleid,
      tripid: tripid || '',
      page_no: pageNum1
    }

     this.$http
      .post(`${CONSTANTS.MISREPORT_API_URL}/getshipmentdetailsforvehicle`, obj)
      .then(result => {
        this.loader = false;

        if (result.data.returnmsg === "Successful") {
          this.loadData = result.data.returnvalue
          this.total_count = result.data.returnvalue[0].total_count
          this.noofpages1=parseInt(this.total_count)/10;
          this.noofpages1=Math.ceil( this.noofpages1);
        }
        else{
          this.loadData =[]
        }
      })
  }, 
 

  goback(){
    this.$router.back()
  },

  getvehiclemovementtoday() {
    const obj = {
      hub_id: this.$route.query.hub_id || '',
      sysusermasterid: this.Usersysuserid,
      warehouseid: this.$route.query.warehouseid || '',
      edd: this.$route.query.edd || '',
      shipmentjourney: this.$route.query.shipmentjourney || '',
    };

    this.$http
      .post(`${CONSTANTS.MISREPORT_API_URL}/getvehiclemovementtoday`, obj)
      .then(result => {
        this.loader = false;

        if (result.data.returnmsg === "Successful") {
          this.vehiclecount = result.data.returnvalue;

          // Map API response to summaryList keys
          const valueMap = {
            OFD: this.vehiclecount.OFD || 0,
            PickDone: this.vehiclecount.PickDone || 0,
            LH: this.vehiclecount.LH || 0,
            NationalLH: this.vehiclecount.NationalLH || 0
          };

          this.summaryList.forEach(item => {
            if (valueMap[item.key] !== undefined) {
              item.value = valueMap[item.key];
            }
          });
        } else {
          
              // Map API response to summaryList keys
          const valueMap = {
            OFD: 0,
            PickDone:  0,
            LH: 0,
            NationalLH: 0
          };

          this.summaryList.forEach(item => {
            if (valueMap[item.key] !== undefined) {
              item.value = valueMap[item.key];
            }
          });

          this.summaryList.forEach(item => {
            item.value = 0;
          });
        }
      });
  },

  getvehiclewisehubdetails(){
    this.loader= true;
    const obj = {
      hub_id: this.$route.query.hub_id || '',
      sysusermasterid: this.Usersysuserid,
      warehouseid: this.$route.query.warehouseid || '',
      edd: this.$route.query.edd || '',
      shipmentjourney: this.$route.query.shipmentjourney || '',
      shipmentstatus: this.selectedstatus,
    };

    this.$http
      .post(`${CONSTANTS.MISREPORT_API_URL}/getvehiclewisehubdetails`, obj)
      .then(result => {
        this.loader = false;

        if (result.data.returnmsg === "Successful") {
        
          this.hubList = result.data.returnvalue
            .map(hub => {

              return {
                name: hub.hub_title,
                count: hub.total_count || 0,
                id: hub.currenthubid
              };
            })
        }
        else{
          
        }
      })
  }
    

}
}
</script>

<style scoped>
.shipment-box {
  background-color: #20a8d8;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #999;
}

.shipment-box .title {
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 5px;
}

.shipment-box .value {
  font-size: 22px;
  font-weight: bold;
  text-align: right;
  padding: 10px;
}
.clickable {
  cursor: pointer;
  transition: 0.2s;
}
.clickable:hover {
  transform: scale(1.02);
}

.hub-section {
  background: #f1f1f1;
  padding: 15px;
  border-radius: 8px;
}

.hub-box {
  background: #d3d3d3;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #888;
}

.hub-title {
  font-weight: bold;
  font-size: 13px;
}

.hub-value {
  font-size: 18px;
  font-weight: bold;
}
.custom-table {
  width: 100%;
  border-collapse: collapse;
  background: #dff0d8;
}

.custom-table th,
.custom-table td {
  border: 1px solid #666;
  padding: 6px;
  text-align: center;
}

.custom-table th {
  background: #c8e6c9;
  font-weight: bold;
}

.clickable-link {
  color: blue;
  cursor: pointer;
  font-weight: bold;
}

.clickable-link:hover {
  text-decoration: underline;
}
</style>